export class MessageSelectEmotion {
    constructor(optionalOptions = {}) {
        this._chatMessageElm = document.getElementById("chat-message-emotion");

        if (!this._chatMessageElm) {
            this.destructor();
            return true;
        }

        window.addLinksEmotion();
    }

    destructor() {
        this._chatMessageElm = null
    }
}

export default new MessageSelectEmotion();